import { fetchAPI } from '../../api';
import { ErrorResponse } from '../../api/fetchAPI';
import { SessionData } from '../../context/Session';

interface MFAToken {
  mfaToken: string;
}

type SignInResponse = SessionData | MFAToken;

export const initiateLogin = async (
  email: string,
  password: string,
  reCaptchaToken: string,
  rememberMe: boolean
) => {
  const endpoint = `v1/sign-in`;
  return await fetchAPI<SignInResponse>(endpoint, {
    method: 'POST',
    body: { rememberMe, email, password, reCaptchaToken },
  });
};

export const mfaChallengeCompletion = async (
  mfaToken: string,
  code: string
) => {
  const endpoint = `v1/mfa/challenge-completion`;
  return await fetchAPI<SessionData & { rememberMe: boolean }>(endpoint, {
    method: 'POST',
    body: { mfaToken, code },
  });
};

export const initiatePasswordReset = async (email: string) => {
  const endpoint = `v1/password-reset`;
  return await fetchAPI<Record<string, never> | ErrorResponse>(endpoint, {
    method: 'POST',
    body: { email },
  });
};
